angular
  .module('fca-used')
  .component('searchForm', {
    templateUrl: 'app/search-form/search-form.html',
    controller: searchFormController,
    controllerAs: 'searchForm',
    bindings: {
      trackLoad: '<'
    }
  })
  .component('searchAdvancedForm', {
    templateUrl: 'app/search-form/advanced-search-form.html',
    controller: searchFormController,
    controllerAs: 'searchForm',
    bindings: {
      trackLoad: '<'
    }
  })
  .component('searchTags', {
    templateUrl: 'app/search-form/search-tags.html',
    controller: searchFormController,
    controllerAs: 'searchForm',
    bindings: {
      trackLoad: '<'
    }
  });

searchFormController.$inject = ['$rootScope', '$window', '$state', '$translate', '$timeout', 'uvl', 'scroll', 'ResultHelper', 'CONFIG', '$q', '$filter', '$log', '$http'];

function searchFormController($rootScope, $window, $state, $translate, $timeout, uvl, scroll, ResultHelper, CONFIG, $q, $filter, $log, $http) {
  var searchForm = this;
  searchForm.resultHelper = ResultHelper;
  searchForm.config = CONFIG;
  searchForm.geolocationRunning = false;
  searchForm.geolocationAvailable = Boolean(navigator.geolocation);
  searchForm.resultIndex = -1;
  searchForm.locate = function () {
    $log.log('geo');
    if (searchForm.geolocationRunning) {
      return;
    }
    searchForm.geolocationRunning = true;
    navigator.geolocation.getCurrentPosition(function (position) {
      $log.log(position);
      searchForm.hereMapsService.reverseGeocode({
        at: position.coords.latitude + ',' + position.coords.longitude
      }, function (result) {
        $log.log(result);
        searchForm.geolocationRunning = false;
        if (result.items.length > 0) {
          var location = getHereMapsLocationLabel(result.items[0]);
          searchForm.resultHelper.lastQuery.location = location;
          searchForm.onFilterChange(true);
        }
      }, $log.log);
    }, function (e) {
      $log.log('navigator.geolocation.getCurrentPosition not working');
      $log.log(e);
    }, {timeout: 30000, enableHighAccuracy: true});
  };

  searchForm.autoCompletePlaces = {
    api: CONFIG.maps.endpoint,
    restrictions: {
      country: CONFIG.market.id
    },
    types: '["geocode"]'
  };

  function setDefaultQuery() {
    searchForm.resultHelper.lastQuery = {
      location: searchForm.resultHelper.lastQuery ? searchForm.resultHelper.lastQuery.location : null,
      extendedArea: Math.min(CONFIG.search.distance.max, Math.max(CONFIG.search.distance.min, CONFIG.search.distance.default)),
      filters: {
        brand: angular.copy(CONFIG.search.brand.default),
        premium: angular.copy(CONFIG.search.premium.default),
        priceCurrent: angular.copy(CONFIG.search.price.default),
        km: angular.copy(CONFIG.search.mileage.default),
        registrationYear: angular.copy(CONFIG.search.year.default),
        power: searchForm.config.search.power.max,
        volume: {
          min: searchForm.config.search.volume.min,
          max: ResultHelper.getUvlVolumeMax()
        }
      },
      fixArea: false
    };
    return searchForm.resultHelper.lastQuery;
  }

  function setSlidersEnabled() {
    var enabled = Boolean(searchForm.resultHelper.lastQuery.location);
    searchForm.filters.distance.disabled = !enabled;
    searchForm.filters.price.disabled = !enabled;
    searchForm.filters.mileage.disabled = !enabled;
    searchForm.filters.year.disabled = !enabled;
    searchForm.filters.power.disabled = !enabled;
    searchForm.filters.volume.disabled = !enabled;
  }

  searchForm.reset = function () {
    setDefaultQuery();
    delete searchForm.resultHelper.vehiclesCount;
    searchForm.onFilterChange(true);
  };

  searchForm.closeModal = function () {
    if (searchForm.resultHelper.modalFilters) {
      angular.element(document).find('html').css('position', 'static');
      angular.element(document).find('body').css('position', 'static');
      searchForm.resultHelper.lastQuery = uvl.getLastQuery();
      delete searchForm.resultHelper.modalFilters;
      searchForm.getVehiclesCount();
    }
  };

  searchForm.submit = function () {
    searchForm.goToResults = false;
    ResultHelper.ordered = false;
    if (searchForm.resultHelper.lastQuery.pagination) {
      searchForm.resultHelper.lastQuery.pagination.page = 0;
    }
    uvl.saveLastFilters(searchForm.filters);

    $state.go('root.results', {
      query: searchForm.resultHelper.lastQuery,
      trackLoad: searchForm.trackLoad
    }, {
      reload: true
    });

    searchForm.closeModal();
  };

  searchForm.locationSuggestionChanged = function (event) {
    // $log.log(searchForm.suggestions);
    switch (event.key) {
      case 'Down':
      case 'ArrowDown':
        searchForm.resultIndex += 1;
        break;
      case 'Up':
      case 'ArrowUp':
        searchForm.resultIndex -= 1;
        break;
      case 'Enter':
        searchForm.setLocation(searchForm.resultIndex, event);
        break;
      default:
        $log.log(event.key);
    }

    if (searchForm.resultHelper.lastQuery.location && searchForm.resultHelper.lastQuery.location.locality) {
      $q.when(getSuggestions(searchForm.resultHelper.lastQuery.location.locality))
        .then(function (suggestions) {
/*
          $log.log(suggestions);
*/
          searchForm.suggestions = suggestions.suggestions;
        });
    } else {
      searchForm.suggestions = [];
    }
  };

  searchForm.setLocation = function (index, $event) {
    var locationId = searchForm.suggestions[index].locationId;
    $q.when(getLocationDetail(locationId)).then(function (place) {
      if (place.response.view.length > 0 && place.response.view[0].result.length > 0) {
        var location = getHereMapsLocationLabelFromLocationDetail(place.response.view[0].result[0].location);
        searchForm.resultHelper.lastQuery.location = location;
        searchForm.onFilterChange(true);
        searchForm.suggestions = [];
        searchForm.resultIndex = -1;
      }
    }
    );
    $event.stopPropagation();
  };

  searchForm.locationChanged = function () {
    delete searchForm.filters.models;
    delete searchForm.filters.fuels;
    delete searchForm.filters.gears;
    delete searchForm.filters.colors;
    delete searchForm.filters.transmissions;
    delete searchForm.filters.brands;
    delete searchForm.filters.vehicleType;
    delete searchForm.filters.bodyType;
    delete searchForm.filters.typeOfUse;
    delete searchForm.filters.wheelBase;
    delete searchForm.resultHelper.lastQuery.filters.model;
    if (searchForm.resultHelper.lastQuery.filters.brand && !CONFIG.search.brand.default) {
      delete searchForm.resultHelper.lastQuery.filters.brand;
    } else {
      searchForm.resultHelper.lastQuery.filters.brand = CONFIG.search.brand.default;
    }
  };

  searchForm.getCount = function () {
    return {
      count: searchForm.resultHelper.getCount() || 0
    };
  };

  function getSuggestions(query) {
/* https://developer.here.com/documentation/geocoder-autocomplete/dev_guide/topics/resource-suggest.html */
    var defer = $q.defer();
    var hereMapsAutocompleteUrl = 'https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json?' +
      'query=' + encodeURIComponent(query) +
      '&beginHighlight=' + encodeURIComponent('<b>') +
      '&endHighlight=' + encodeURIComponent('</b>') +
      '&country=' + CONFIG.maps.country +
      '&language=' + CONFIG.language.id +
/*      '&resultType=city' + not working as expected */
      '&maxresults=5' +
      '&apiKey=' + CONFIG.maps.hereMapsApiKey;
    $http.get(hereMapsAutocompleteUrl)
      .then(function (response) {
        if (response.status === 200) {
          return defer.resolve(response.data);
        }
        defer.reject();
      });
    return defer.promise;
  }

  function getLocationDetail(locationId) {
/*
    https://developer.here.com/documentation/geocoder-autocomplete/dev_guide/topics/example-location-id.html
*/
    var defer = $q.defer();
    var hereMapsAutocompleteUrl = 'https://geocoder.ls.hereapi.com/6.2/geocode.json?locationId=' + locationId + '&gen=9&jsonattributes=1&apiKey=' + CONFIG.maps.hereMapsApiKey;
    $http.get(hereMapsAutocompleteUrl)
      .then(function (response) {
        if (response.status === 200) {
          return defer.resolve(response.data);
        }
        defer.reject();
      });
    return defer.promise;
  }

  searchForm.getVehiclesCount = function () {
    uvl.getVehiclesCount(searchForm.resultHelper.lastQuery)
      .then(function (count) {
        if (count && searchForm.goToResults) {
          searchForm.submit();
        }
      });
  };

  function showUpdateButton(doShow) {
    if (doShow) {
      searchForm.resultHelper.lastQuery.submit = searchForm.submit;
    } else {
      delete searchForm.resultHelper.lastQuery.submit;
    }
  }

  function isQueryChanged() {
    var lastSentQuery = uvl.getLastQuery();
    var lastQuery = angular.copy(searchForm.resultHelper.lastQuery);
    if (lastQuery && lastSentQuery) {
      delete lastQuery.order;
      delete lastQuery.pagination;
      delete lastSentQuery.order;
      delete lastSentQuery.pagination;
    }
    angular.forEach(lastQuery.filters, function (elem, key) {
      if (elem === null) {
        delete lastQuery.filters[key];
      }
    });
    return !angular.equals(lastQuery, lastSentQuery);
  }

  function renderSliders() {
    $timeout(function () {
      $rootScope.$broadcast('rzSliderForceRender');
    }, 0);
  }

  searchForm.onFilterChange = function (doGetValues) {
    var queryChanged = isQueryChanged();
    // trackLoad is always true when it's passed from home
    showUpdateButton(queryChanged || searchForm.trackLoad);

    if (!searchForm.resultHelper.lastQuery.filters.brand) {
      delete searchForm.resultHelper.lastQuery.filters.brand;
    }

    // Delete model if set by defaultModel
    if (!searchForm.resultHelper.lastQuery.filters.model ||
      (angular.equals(searchForm.resultHelper.lastQuery.filters.model, searchForm.defaultModel) && ResultHelper.firstSearch)) {
      delete searchForm.resultHelper.lastQuery.filters.model;
    }
    if (!searchForm.resultHelper.lastQuery.filters.power) {
      searchForm.resultHelper.lastQuery.filters.power = searchForm.config.search.power.max;
    }
    if (!searchForm.resultHelper.lastQuery.filters.fuel) {
      delete searchForm.resultHelper.lastQuery.filters.fuel;
    }
    if (!searchForm.resultHelper.lastQuery.filters.gear) {
      delete searchForm.resultHelper.lastQuery.filters.gear;
    }
    if (!searchForm.resultHelper.lastQuery.filters.color) {
      delete searchForm.resultHelper.lastQuery.filters.color;
    }
    if (!searchForm.resultHelper.lastQuery.filters.transmission) {
      delete searchForm.resultHelper.lastQuery.filters.transmission;
    }
    if (!searchForm.resultHelper.lastQuery.filters.vehicleType) {
      delete searchForm.resultHelper.lastQuery.filters.vehicleType;
    }
    if (!searchForm.resultHelper.lastQuery.filters.bodyType) {
      delete searchForm.resultHelper.lastQuery.filters.bodyType;
    }
    if (!searchForm.resultHelper.lastQuery.filters.typeOfUse) {
      delete searchForm.resultHelper.lastQuery.filters.typeOfUse;
    }
    if (!searchForm.resultHelper.lastQuery.filters.wheelBase) {
      delete searchForm.resultHelper.lastQuery.filters.wheelBase;
    }
    if (!searchForm.resultHelper.lastQuery.filters.volume) {
      searchForm.resultHelper.lastQuery.filters.volume = {
        min: searchForm.config.search.volume.min,
        max: ResultHelper.getUvlVolumeMax()
      };
    }

    setSlidersEnabled();

    if (!doGetValues) {
      renderSliders();
      // if (!queryChanged && !searchForm.trackLoad) {
      //   return;
      // }
      searchForm.getVehiclesCount();
      return;
    }
    var query = angular.copy(ResultHelper.lastQuery);
    query.filters.priceCurrent.max = CONFIG.search.price.max;
    // query.filters.km = CONFIG.search.mileage.max;

    uvl.getValues(query, ['priceCurrent', 'km', 'registrationYear', 'volume'])
      .then(function (filters) {
        // No mandate
        if (angular.equals(filters, {})) {
          delete searchForm.filters.models;
          delete searchForm.filters.fuels;
          delete searchForm.filters.gears;
          delete searchForm.filters.colors;
          delete searchForm.filters.transmissions;
          delete searchForm.filters.brands;
          delete searchForm.filters.vehicleType;
          delete searchForm.filters.bodyType;
          delete searchForm.filters.typeOfUse;
          delete searchForm.filters.wheelBase;
        }
        if (!filters.groups) {
          renderSliders();
          searchForm.getVehiclesCount();
          return;
        }
        if (filters.groups.brandCode) {
          searchForm.filters.brands = filters.groups.brandCode;
        }

        if (filters.groups.modelCode) {
          searchForm.filters.models = filters.groups.modelCode;

          // Re-select the default model, if you should
          if (searchForm.defaultModel) {
            var index = searchForm.filters.models
              .map(function (model) {
                return model.brandModelCode;
              })
              .indexOf(searchForm.defaultModel.brandModelCode);
            if (index > -1) {
              searchForm.resultHelper.lastQuery.filters.model = searchForm.filters.models[index];
            }
          }
        }
        if (filters.groups.fuelCode) {
          searchForm.filters.fuels = filters.groups.fuelCode;
        }
        if (filters.groups.gearCode) {
          searchForm.filters.gears = filters.groups.gearCode;
        }
        if (filters.groups.bodyColorCode) {
          searchForm.filters.colors = filters.groups.bodyColorCode;
        }
        if (filters.groups.transmissionTypeCode) {
          searchForm.filters.transmissions = filters.groups.transmissionTypeCode;
        }
        if (filters.groups.vehicleType) {
          searchForm.filters.vehicleType = filters.groups.vehicleType;
        }
        if (filters.groups.bodyTypeCode) {
          searchForm.filters.bodyType = filters.groups.bodyTypeCode;
        }
        if (filters.groups.typeOfUseCode) {
          searchForm.filters.typeOfUse = filters.groups.typeOfUseCode;
        }
        if (filters.groups.wheelBaseCode) {
          searchForm.filters.wheelBase = filters.groups.wheelBaseCode;
        }

        if (filters.stats.priceCurrent) {
          searchForm.filters.price.ceil = CONFIG.search.price.step * Math.ceil(filters.stats.priceCurrent.max / CONFIG.search.price.step);
          query.filters.priceCurrent.max = ResultHelper.lastQuery.filters.priceCurrent.max = searchForm.filters.price.ceil;
          query.filters.priceCurrent.min = ResultHelper.lastQuery.filters.priceCurrent.min = CONFIG.search.price.min;
        }

        if (filters.stats.volume) {
          searchForm.filters.volume.floor = CONFIG.search.volume.min;
          searchForm.filters.volume.ceil = filters.stats.volume.max;
          query.filters.volume.min = ResultHelper.lastQuery.filters.volume.min = searchForm.filters.volume.floor;
          query.filters.volume.max = ResultHelper.lastQuery.filters.volume.max = searchForm.filters.volume.ceil;
          ResultHelper.setUvlVolumeMax(filters.stats.volume.max);
        } else {
          ResultHelper.lastQuery.filters.volume = {
            min: CONFIG.search.volume.min,
            max: ResultHelper.getUvlVolumeMax()
          };
        }

        // if (filters.stats.km) {
        //   searchForm.filters.mileage.ceil = CONFIG.search.mileage.step * Math.ceil(filters.stats.km.max / CONFIG.search.mileage.step);
        //   query.filters.km = Math.min(searchForm.resultHelper.lastQuery.filters.km, searchForm.filters.mileage.ceil);
        //   ResultHelper.lastQuery.filters.km = query.filters.km;
        // }
        // uvl.saveLastQuery(query);
        renderSliders();
        searchForm.getVehiclesCount();
      });
  };

  searchForm.brandChanged = function () {
    delete searchForm.filters.models;
    delete searchForm.resultHelper.lastQuery.filters.model;
    searchForm.onFilterChange();
  };

  searchForm.removeFilter = function (type) {
    switch (type) {
      case 'premium':
        searchForm.resultHelper.lastQuery.filters.premium = false;
        break;
      case 'price':
        searchForm.resultHelper.lastQuery.filters.priceCurrent.min = searchForm.filters.price.floor;
        searchForm.resultHelper.lastQuery.filters.priceCurrent.max = searchForm.filters.price.ceil;
        break;
      case 'year':
        searchForm.resultHelper.lastQuery.filters.registrationYear.min = searchForm.filters.year.floor;
        searchForm.resultHelper.lastQuery.filters.registrationYear.max = searchForm.filters.year.ceil;
        break;
      case 'km':
        searchForm.resultHelper.lastQuery.filters.km = searchForm.filters.mileage.ceil;
        break;
      case 'power':
        searchForm.resultHelper.lastQuery.filters.power = searchForm.filters.power.ceil;
        break;
      case 'volume':
        searchForm.resultHelper.lastQuery.filters.volume.min = searchForm.filters.volume.floor;
        searchForm.resultHelper.lastQuery.filters.volume.max = searchForm.filters.volume.ceil;
        break;
      default:
        delete searchForm.resultHelper.lastQuery.filters[type];
        break;
    }

    searchForm.onFilterChange();
    searchForm.submit();
  };

  function loadScript(src) {
    var deferred = $q.defer();
    var script = $window.document.createElement('script');
    script.onload = script.onreadystatechange = function (e) {
      $timeout(function () {
        deferred.resolve(e);
      });
    };
    script.onerror = function (e) {
      $timeout(function () {
        deferred.reject(e);
      });
    };
    script.src = src;
    $window.document.body.appendChild(script);
    return deferred.promise;
  }

  searchForm.$onInit = function () {
    searchForm.resultHelper.lastQuery = searchForm.resultHelper.lastQuery || setDefaultQuery();
    searchForm.scroll = scroll;
    loadScript(CONFIG.maps.hereMapsEndpoint).then(function () {
      loadScript(CONFIG.maps.hereMapsServiceEndpoint).then(function () {
        var platform = new $window.H.service.Platform({
          apikey: CONFIG.maps.hereMapsApiKey
        });
        searchForm.hereMapsService = platform.getSearchService();
        searchForm.suggestions = [];
      }).catch(function (e) {
        $log.log(e);
      });
    }).catch(function (e) {
      $log.log(e);
    });

    ResultHelper.filters = ResultHelper.filters || {
      distance: {
        floor: CONFIG.search.distance.min,
        ceil: CONFIG.search.distance.max,
        step: CONFIG.search.distance.step,
        showSelectionBar: true,
        disabled: true
      },
      price: {
        floor: CONFIG.search.price.min,
        ceil: CONFIG.search.price.max,
        step: CONFIG.search.price.step,
        disabled: true
      },
      mileage: {
        floor: CONFIG.search.mileage.min,
        ceil: CONFIG.search.mileage.max,
        stepsArray: CONFIG.search.mileage.steps,
        showSelectionBar: true,
        disabled: true
      },
      year: {
        floor: CONFIG.search.year.min,
        ceil: CONFIG.search.year.max,
        step: CONFIG.search.year.step,
        disabled: true
      },
      power: {
        floor: CONFIG.search.power.min,
        ceil: CONFIG.search.power.max,
        step: CONFIG.search.power.step,
        showSelectionBar: true,
        disabled: true
      },
      volume: {
        floor: CONFIG.search.volume.min,
        ceil: CONFIG.search.volume.max,
        step: CONFIG.search.volume.step,
        disabled: true
      }
    };
    searchForm.filters = ResultHelper.filters;

    searchForm.filters.distance.onEnd = function () {
      searchForm.onFilterChange(true);
    };
    searchForm.filters.distance.translate = function (value, slider, label) {
      if (label === 'model') {
        var text = '<em>' + $translate.instant('search_distance_to');
        text += '</em> ' + CONFIG.search.distance.unit;
        text += ' ' + value;
        return text;
      }
      return value;
    };
    searchForm.filters.price.onEnd = searchForm.onFilterChange;
    searchForm.filters.price.translate = function (value, slider, label) {
      if (CONFIG.search.price.thousandsSeparator) {
        value = $filter('number')(value, 0);
      }
      var text;
      switch (label) {
        case 'model':
          text = '<em>' + $translate.instant('search_filter_from') + '</em>';
          text += ' ' + CONFIG.search.price.unit;
          text += ' ' + value;
          break;
        case 'high':
          text = '<em>' + $translate.instant('search_filter_to') + '</em>';
          text += ' ' + CONFIG.search.price.unit;
          text += ' ' + value;
          break;
        default:
          text = value;
          break;
      }
      return text;
    };
    searchForm.filters.mileage.onEnd = searchForm.onFilterChange;
    searchForm.filters.mileage.translate = function (value, slider, label) {
      if (CONFIG.search.mileage.thousandsSeparator) {
        value = $filter('number')(value, 0);
      }
      if (label === 'model') {
        var text = '<em>' + $translate.instant('search_mileage_to');
        text += '</em> ' + CONFIG.search.mileage.unit;
        text += ' ' + value;
        return text;
      }
      return value;
    };
    searchForm.filters.year.onEnd = searchForm.onFilterChange;
    searchForm.filters.year.translate = function (value, slider, label) {
      var text;
      switch (label) {
        case 'model':
          text = '<em>' + $translate.instant('search_filter_from') + '</em>';
          text += ' ' + value;
          break;
        case 'high':
          text = '<em>' + $translate.instant('search_filter_to') + '</em>';
          text += ' ' + value;
          break;
        default:
          text = value;
          break;
      }
      return text;
    };
    searchForm.filters.volume.onEnd = searchForm.onFilterChange;
    searchForm.filters.volume.translate = function (value, slider, label) {
      var text;
      switch (label) {
        case 'model':
          text = '<em>' + $translate.instant('search_filter_from') + '</em>';
          text += ' ' + value;
          text += ' ' + CONFIG.search.volume.unit;
          break;
        case 'high':
          text = '<em>' + $translate.instant('search_filter_to') + '</em>';
          text += ' ' + value;
          text += ' ' + CONFIG.search.volume.unit;
          break;
        default:
          text = value;
          break;
      }
      return text;
    };
    searchForm.filters.power.onEnd = searchForm.onFilterChange;
    searchForm.filters.power.translate = function (value, slider, label) {
      if (label === 'model') {
        var text = '<em>' + $translate.instant('search_power_to');
        text += '</em> ' + CONFIG.search.power.unit;
        text += ' ' + value;
        return text;
      }
      return value;
    };
    if (Boolean(searchForm.resultHelper.lastQuery.location) && Boolean(searchForm.resultHelper.lastQuery.location.geometry)) {
      searchForm.onFilterChange(false);
    }

    // Init default model
    if (CONFIG.search.model && CONFIG.search.model.defaultModel && ResultHelper.firstSearch) {
      searchForm.defaultModel = CONFIG.search.model.defaultModel;
      searchForm.filters.models = [searchForm.defaultModel];
      searchForm.resultHelper.lastQuery.filters.model = searchForm.defaultModel;
    }

    if (ResultHelper.firstSearch && CONFIG.search.goToResults) {
      searchForm.goToResults = CONFIG.search.goToResults;
      delete CONFIG.search.goToResults;
    }

    if (ResultHelper.firstSearch && CONFIG.search.location) {
      searchForm.locationChanged();
    }

    setSlidersEnabled();
    renderSliders();
  };

  function getHereMapsLocationLabelFromLocationDetail(place) {
    if (!place) {
      return null;
    }
    $log.log(place);
    var addressInfos = {};
    place.address.additionalData.forEach(function (item) {
      addressInfos[item.key] = item.value;
    });

    return ({
      country: addressInfos.CountryName,
      geometry: {lat: place.displayPosition.latitude, lng: place.displayPosition.longitude},
      locality: place.address.label,
/*
      locality: addressInfos.CountyName + ' ' + place.address.county,
*/
      province: place.address.county
    });
  }

  function getHereMapsLocationLabel(place) {
    if (!place) {
      return null;
    }

    return ({
      country: place.address.countryName,
      geometry: {lat: place.position.lat, lng: place.position.lng},
      locality: place.address.label,
      province: place.address.countyCode
    });
  }

  /* eslint-enable camelcase */
}
